import { Container } from '@alice-financial/pretext-ui'
import * as React from 'react'
import { Navigate } from 'react-router'
import { CardRequestTypeEnum } from '@alice-financial/alice-sdk'
import { PageBody } from '../../../routes/PageBody'
import { useAliceCardRequestScope } from './aliceCardUtils'
import { RequestAliceCardForm } from './RequestAliceCardForm'

export const AliceCardRequest = () => {
  const { data: requestScope, isFetching } = useAliceCardRequestScope()
  if (!requestScope && !isFetching) return <Navigate to="/cards/alice" replace />
  return (
    <PageBody>
      <Container>
        <RequestAliceCardForm scope={requestScope || CardRequestTypeEnum.InstantAndPhysical} />
      </Container>
    </PageBody>
  )
}
